module.exports = __webpack_public_path__ + "img/16.d02c9090.jpg";